<template lang="html">
  <div class="slds-grid slds-wrap">
    <div v-for="(grafico,index) in grafici" v-bind:key="grafico.id" class="slds-col" v-bind:class="colonne(index)">
      <card v-bind:title="grafico.title" v-bind:object="'account'">
        <template v-slot:body>
          <canvas v-bind:id="'chart'+index" width="400px" height="100px"></canvas>
        </template>
        <template v-slot:footer>
          <div>{{grafico.subtitle}}</div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import card from './card.vue'
import Chart from 'chart.js';
import apiclient from '@/apiclient.js'

export default {
  name: 'situazione',
  components: {
    card,
  },
  props: {
    dettaglianti: Boolean,
    grossisti: Boolean,
    altro: Boolean
  },
  data() {
    return {
      grafici: [],
      charts:[],
      // campagna: 0,
      // campagnacfr: 6,
      // campagnacfr2: 14,
      colors:['TAN', 'DARKSEAGREEN', 'GREEN'],
      mXIndex: new Map(),
      results: new Map(),

      numero_di_serie: 2
    }
  },
  computed: {
    actualdealer: function() {
      if (this.$store.state.multizona) 
        return this.$store.getters.zona;
      else
        return '';
    },
    campagna() {
      return this.$store.state.campagne.findIndex( c => c == '2026 RE')
    },
    campagnacfr() {
      return this.$store.state.campagne.findIndex( c => c == '2025 RE')
    },
    campagnacfr2() {
      return this.$store.state.campagne.findIndex( c => c == '2024 RE')
    }
  },
  watch: {
    actualdealer: function() {
      this.refresh();
    },
    dettaglianti: function() {
      this.refresh();
    },
    grossisti: function() {
      this.refresh();
    },
    altro: function() {
      this.refresh();
    }
  },
  created: function() {

    console.log('campagne:')
    console.log(this.$store.state.campagne);
    
    var o1= {
      responsive: true, legend: { display: false },
      scales: { yAxes: [{ ticks: { beginAtZero: true } } ] }
    };
    var o2= {
      responsive: true, legend: { display: false },
    };

    this.grafici.push({ 
      id:1, query: 0, colors: 'fc0', ndata: 1, fprog:false, title: 'Clienti serviti '+this.$store.state.campagne[this.campagnacfr], subtitle: 'Totale clienti con ordini', width: 6, type:'bar', options: o1 
    });
    this.grafici.push({ 
      id:2, query: 1, colors: 'fc1', ndata: 1, fprog:false, title: 'Clienti serviti '+this.$store.state.campagne[this.campagna], subtitle: 'Totale clienti con ordini e visite negative', width: 6, type:'bar', options: o1
    });
    this.grafici.push({ 
      id:3,  query: 2, colors: 'lc', ndata: this.numero_di_serie, fprog:false,  title: 'N.Clienti '+this.$store.state.campagne[this.campagnacfr]+' vs '+this.$store.state.campagne[this.campagna], subtitle: 'Settimana di campagna', width: 6, type:'line', options: o1
    });
    this.grafici.push({ 
      id:4,  query: 2, colors: 'fc', ndata: this.numero_di_serie, fprog:false, title: '€ Ordini '+this.$store.state.campagne[this.campagnacfr]+' vs '+this.$store.state.campagne[this.campagna], subtitle: 'Settimana di campagna', width: 6, type:'bar', options: o2
    });
    this.grafici.push({ 
      id:5,  query: 2, colors: 'lc', ndata: this.numero_di_serie, fprog:true, title: 'Prog.Clienti '+this.$store.state.campagne[this.campagnacfr]+' vs '+this.$store.state.campagne[this.campagna], subtitle: 'Settimana di campagna', width: 6, type:'line', options: o1
    });
    this.grafici.push({ 
      id:6,  query: 2, colors: 'lc', ndata: this.numero_di_serie, fprog:true, title: 'Prog.€ Ordini '+this.$store.state.campagne[this.campagnacfr]+' vs '+this.$store.state.campagne[this.campagna], subtitle: 'Settimana di campagna', width: 6, type:'line', options: o2
    });
  },
  mounted: function() {    
    this.grafici.forEach(function(d,i) {
      this.doGraph(i);
      this.doData(i);
    }, this);
    
  },
  methods: {
    refresh: function() {
      this.grafici.forEach(function(d,i) {
        this.doGraph(i);
        this.doData(i);
      }, this);
    },
    colonne: function(i) {
      return 'slds-size_'+this.grafici[i].width+'-of-12';
    },
    convertCampaign: function(c) {
      // 2020 PW
      return c.substr(5,2)+c.substr(0,4);
    },
    getDettaglianti: function(c) {
      // 2020 PW
      var campagna=c.substr(0,2);
      var anno=c.substr(2,4);
      console.log('getDettaglianti:'+c+' '+campagna+' '+anno);
      switch(campagna) {
        case 'MO':
          return campagna+anno+'D';
        case 'VF':
          return campagna+anno+'D';
        case 'VS':
          return campagna+anno+'D';
        case 'PW':
          return campagna+anno+'D';
        case 'SC':
          return campagna+anno+'A';
        case 'NA':
          return campagna+anno+'A';
        case 'RE':
          return campagna+anno+'R';
      }
    },
    getGrossisti: function(c) {
      // 2020 PW
      var campagna=c.substr(0,2);
      var anno=c.substr(2,4);
      console.log('getGrossisti:'+c+' '+campagna+' '+anno);
      switch(campagna) {
        case 'MO':
          return campagna+anno+'G';
        case 'VF':
          return campagna+anno+'G';
        case 'VS':
          return campagna+anno+'G';
        case 'PW':
          return campagna+anno+'G';
        case 'SC':
          return campagna+anno+'G';
        case 'NA':
          return campagna+anno+'G';
        case 'RE':
          return campagna+anno+'G';
      }
    },
    getCampagna: function(c) {
      // 2020 PW
      var campagna=c.substr(0,2);
      var anno=c.substr(2,4);
      return campagna+anno;
    },
    areaFilter: function() {
      if (this.$store.getters.zona<'990')
          return " and keysoggetto like '%"+this.$store.getters.zona+"%' ";

      var sql='';
      switch (this.$store.getters.zona)
        {
          case '991':
            sql+=" and Area='AREA_1W' ";
            break;
          case '996':
            sql+=" and Area='AREA_1E' ";
            break;
          case '992':
            sql+=" and Area='AREA_2NORD' ";
            break;
          case '993':
            sql+=" and Area='AREA_2SUD' ";
            break;
          case '994':
            sql+=" and Area='AREA_3' ";
            break;
          case '995':
            sql+=" and Area='AREA_4' ";
            break;
        }
      return sql;
    },
    doData: function(i) {
      console.log('doData:'+i);
      console.log('filters:'+this.dettaglianti+' '+this.grossisti+' '+this.altro);

      var c=this.getCampagna( this.convertCampaign(this.$store.state.campagne[this.campagna]) );
      var c1=this.getCampagna( this.convertCampaign(this.$store.state.campagne[this.campagnacfr]) );
      var d=this.getDettaglianti( this.convertCampaign(this.$store.state.campagne[this.campagna]) );
      var d1=this.getDettaglianti( this.convertCampaign(this.$store.state.campagne[this.campagnacfr]) );
      var g=this.getGrossisti( this.convertCampaign(this.$store.state.campagne[this.campagna]) );
      var g1=this.getGrossisti( this.convertCampaign(this.$store.state.campagne[this.campagnacfr]) );

      if(this.numero_di_serie == 3) {
        var c2=this.getCampagna( this.convertCampaign(this.$store.state.campagne[this.campagnacfr2]) );
        var d2=this.getDettaglianti( this.convertCampaign(this.$store.state.campagne[this.campagnacfr2]) );
        var g2=this.getGrossisti( this.convertCampaign(this.$store.state.campagne[this.campagnacfr2]) );
      }

      var sql="";
      switch(this.grafici[i].query) {
        case 0:
          sql='select count (distinct (keycli)) as qty_clienti, KEYCOPYCOMM, keysoggetto from giusti2.ORDTESTATOT ';
          sql+=' left join `fcpanini-208106.DataWarehouse.dim_Agente` as agenti on (substr(keysoggetto,3,3)=agenti.Codice) ';
          sql+=' where ';

          var w=[];
          if (this.dettaglianti) w.push('trim(KEYCOPYCOMM)=\''+d1+'\' ');
          if (this.grossisti) w.push('trim(KEYCOPYCOMM)=\''+g1+'\' ');
          if (this.altro) w.push(' trim(KEYCOPYCOMM) like \''+c1+'%\' AND ( trim(KEYCOPYCOMM)!=\''+d1+'\' AND trim(KEYCOPYCOMM)!=\''+g1+'\' )');
          if (w.length>0)
            sql+='('+w.join(' OR ')+')';

          sql+=this.areaFilter();
          sql+=" group by KEYCOPYCOMM, keysoggetto ";
        break;
        case 1:
          sql='select count (distinct (keycli)) as qty_clienti, KEYCOPYCOMM, keysoggetto from giusti2.ORDTESTATOT ';
          sql+=' left join `fcpanini-208106.DataWarehouse.dim_Agente` as agenti on (substr(keysoggetto,3,3)=agenti.Codice) ';
          sql+=' where ';

          var w=[];
          if (this.dettaglianti) w.push('trim(KEYCOPYCOMM)=\''+d+'\' ');
          if (this.grossisti) w.push('trim(KEYCOPYCOMM)=\''+g+'\' ');
          if (this.altro) w.push(' trim(KEYCOPYCOMM) like \''+c+'%\' AND ( trim(KEYCOPYCOMM)!=\''+d+'\' AND trim(KEYCOPYCOMM)!=\''+g+'\' )');
          if (w.length>0)
            sql+='('+w.join(' OR ')+')';

          sql+=this.areaFilter();
          sql+=" group by KEYCOPYCOMM, keysoggetto ";
        break;
        case 2:
          sql='select substr(ORDTESTATOT.KEYCOPYCOMM,0, 2) as cc, ';
          sql+='substr(substr(ORDTESTATOT.KEYCOPYCOMM,3),0,4) as anno_cc, count (distinct (keycli)) as qty_clienti,  ROUND(SUM ( (TOTORD)),2) AS totale_testate, FLOOR((TIMESTAMP_DIFF(  DATAORD , dataini , day)+1)/7)+1  as settimana , min (dataord) as datamin, max (dataord) as datamax ';
          sql+='from giusti2.ORDTESTATOT left join giusti2.COPYTESTATOT on trim(ORDTESTATOT.KEYCOPYCOMM) = trim(copytestatot.keycopycomm) ';
          sql+=' left join `fcpanini-208106.DataWarehouse.dim_Agente` as agenti on (substr(keysoggetto,3,3)=agenti.Codice) ';
          sql+=' where ';
//          sql+='where (ORDTESTATOT.KEYCOPYCOMM like \''+this.convertCampaign(this.$store.state.campagne[this.campagna])+'%\' or ORDTESTATOT.KEYCOPYCOMM like \''+this.convertCampaign(this.$store.state.campagne[this.campagnacfr])+'%\' or ORDTESTATOT.KEYCOPYCOMM like \''+this.convertCampaign(this.$store.state.campagne[this.campagnacfr2])+'%\' ) 

          var w=[];
          if (this.dettaglianti) {
            w.push('trim(ORDTESTATOT.KEYCOPYCOMM)=\''+d+'\' ');
            w.push('trim(ORDTESTATOT.KEYCOPYCOMM)=\''+d1+'\' ');
            if(this.numero_di_serie == 3) w.push('trim(ORDTESTATOT.KEYCOPYCOMM)=\''+d2+'\' ');
          }
          if (this.grossisti) {
            w.push('trim(ORDTESTATOT.KEYCOPYCOMM)=\''+g+'\' ');
            w.push('trim(ORDTESTATOT.KEYCOPYCOMM)=\''+g1+'\' ');
            if(this.numero_di_serie == 3) w.push('trim(ORDTESTATOT.KEYCOPYCOMM)=\''+g2+'\' ');
          }
          if (this.altro) {
            w.push(' trim(ORDTESTATOT.KEYCOPYCOMM) like \''+c+'%\' AND ( trim(ORDTESTATOT.KEYCOPYCOMM)!=\''+d+'\' AND trim(ORDTESTATOT.KEYCOPYCOMM)!=\''+g+'\' )');
            w.push(' trim(ORDTESTATOT.KEYCOPYCOMM) like \''+c1+'%\' AND ( trim(ORDTESTATOT.KEYCOPYCOMM)!=\''+d1+'\' AND trim(ORDTESTATOT.KEYCOPYCOMM)!=\''+g1+'\' )');
            if(this.numero_di_serie == 3) w.push(' trim(ORDTESTATOT.KEYCOPYCOMM) like \''+c2+'%\' AND ( trim(ORDTESTATOT.KEYCOPYCOMM)!=\''+d2+'\' AND trim(ORDTESTATOT.KEYCOPYCOMM)!=\''+g2+'\' )');
          }

          if (w.length>0)
            sql+='('+w.join(' OR ')+')';

          sql+=' and FLOOR((TIMESTAMP_DIFF(  DATAORD , dataini , day)+1)/7)+1<=FLOOR((TIMESTAMP_DIFF(  cast(current_date as timestamp), dataini , day)+1)/7)+1 ';
          sql+="and FLOOR((TIMESTAMP_DIFF(  DATAORD , dataini , day)+1)/7)+1>0 ";
          sql+=this.areaFilter();
          sql+='group by cc,  anno_cc, settimana ';
          sql+='order by cc, anno_cc, settimana ';
        break;
      }

      console.log(sql);
      this.grafici[i]['sql'] = sql

      var self=this;
      apiclient.getBQ(this.$store.getters.connection, sql)
        .then(function(records) {

          self.results.set('grafico-'+i, records)
          self.grafici[i]['records'] = records

          var myChart=self.charts[i];
          // console.log('getBQ');
          // console.log(records);
          var x='';
          var y='';
          var z='';
          switch(self.grafici[i].id) {
            case 1:
              x='KEYCOPYCOMM';
              y='qty_clienti';
              z=undefined;
            break;
            case 2:
              x='KEYCOPYCOMM';
              y='qty_clienti';
              z=undefined;
            break;
            case 3:
            case 5:
              x='settimana';
              y='qty_clienti';
              z='anno_cc';
            break;
            case 4:
            case 6:
              x='settimana';
              y='totale_testate';
              z='anno_cc';
            break;
          }

          myChart.data.labels=[];

          self.grafici[i]['x'] = x
          self.grafici[i]['y'] = y
          self.grafici[i]['z'] = z

          // init dataset
          for (var nd=0; nd<self.grafici[i].ndata; nd++) {
            if (myChart.data.datasets && myChart.data.datasets[nd])
              myChart.data.datasets[nd].data=[];
            else {
              console.log('skip dataset!!!'+nd);
              console.log(myChart.data.datasets);
            }
          }

          var xmap=new Map();
          var zmap=new Map();
          var progmap=new Map();
          var fprog=self.grafici[i].fprog;
          records.forEach(function(d) {
            var xval=0;
            if (x) xval=d[x]; // x
            else xval=y; // x

            if (!xmap.has(xval)) {
              xmap.set(xval);
              if( i < 2 ) myChart.data.labels.push(xval); // x
            }

            var dval=d[y];
            var nd=0;

            if (z) {
              if (!zmap.has(d[z])) zmap.set(d[z], zmap.size);
              nd=zmap.get(d[z]);
            }
            if (fprog) {
              if (!progmap.has(nd)) progmap.set(nd,0);
              dval= progmap.get(nd) + dval ;
              progmap.set( nd, dval );
            }
            myChart.data.datasets[nd].data.push(dval); // y
        
            if(!myChart.data.datasets[nd].mapdata) {
              myChart.data.datasets[nd]['mapdata'] = new Map()
            }
            myChart.data.datasets[nd].mapdata.set(xval, dval)

            var datasetN = myChart.data.datasets[nd]
            if(datasetN.startFrom === undefined || xval < datasetN.startFrom) myChart.data.datasets[nd].startFrom = xval
            if(datasetN.endFrom == undefined || xval > datasetN.endFrom) myChart.data.datasets[nd].endFrom = xval

            if(!this.grafici[i].firstWeek || xval < this.grafici[i].firstWeek) this.grafici[i].firstWeek = xval
            if(!this.grafici[i].lastWeek || xval > this.grafici[i].lastWeek) this.grafici[i].lastWeek = xval

            this.grafici[i]['data'] = myChart.data
          },self);

          if( i >= 2 ) {
            for(var j = 1; j <= self.grafici[i].lastWeek; j++) {
              myChart.data.labels.push(j)
            }

            if(self.grafici[i].data && self.grafici[i].data.datasets) {
              self.grafici[i].data.datasets.forEach( (dataset, index) => {
                // console.log('dataset', dataset, index)
                var dati = []
                for(var p = 1; p <= self.grafici[i].lastWeek; p++) {
                  if(dataset.mapdata && dataset.mapdata.has(p)) dati.push(dataset.mapdata.get(p))
                  else dati.push(NaN)
                }
                dataset.data = dati
              })
            }
          }

          if (zmap.size==0) zmap.set('dummy', 1);

          var c=self.grafici[i].colors;
          for (var nd1=0; nd1<zmap.size; nd1++) {
            if (c=='lc') myChart.data.datasets[nd1].borderColor=self.colors[nd1];
            if (c=='fc') myChart.data.datasets[nd1].backgroundColor=self.colors[nd1];
            if (c=='fc0') myChart.data.datasets[nd1].backgroundColor=self.colors[0+1];
            if (c=='fc1') myChart.data.datasets[nd1].backgroundColor=self.colors[1+1];
          }

          // console.log('myChart');
          // console.log(myChart);

          myChart.update();
        }).catch(function(err) {
          console.error(JSON.stringify(err));
        });
    },
    doGraph: function(i) {
      console.log('doGraph');

      var ctx = document.getElementById('chart'+i);
      // console.log(ctx);
      var myChart = new Chart(ctx, {
          type: this.grafici[i].type,
          data: {
              labels: [],
              datasets: []
              /*{
                label: this.grafici[i].title,
                data: [],
              }],
              */
          },
          options: this.grafici[i].options
      });

      // console.log('myChart.data.datasets');
      // console.log(myChart.data.datasets);
      for (var nd=0; nd<this.grafici[i].ndata; nd++)
      {
        myChart.data.datasets.push({
          label: this.grafici[i].title,
          data: [],
        });
      }


      myChart.update();

      // console.log(myChart.data.datasets);
//      Vue.set(this.charts, i, myChart);
      this.charts.push(myChart);
    }

  }
}
</script>

<style scoped>

</style>
